var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.7998L12 19.1998M19.2 11.9998L4.80005 11.9998",
    stroke: "url(#paint0_linear_3459_26810)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3459_26810",
    x1: 12,
    y1: 4.7998,
    x2: 12,
    y2: 19.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04349E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGradient);
export default __webpack_public_path__ + "static/media/plus-gradient.680ce401fea70fd9bd6ba6e96def995a.svg";
export { ForwardRef as ReactComponent };